import { ContentPreviewer } from '@shared/components';
import { useCallback, useEffect, useState } from 'react';

import { useParseContentForQuestionCreationTask } from '../../hooks';

function useParseTaskContent(taskId: string, content: string) {
  const { parseContentForQuestionCreationTask } = useParseContentForQuestionCreationTask({
    taskId,
  });
  const [parsedContent, setParsedContent] = useState('');

  const handleParsedImage = useCallback(async () => {
    if (!content) return;

    const parsedContent = await parseContentForQuestionCreationTask(content);

    setParsedContent(parsedContent);
  }, [content, parseContentForQuestionCreationTask]);

  useEffect(() => {
    handleParsedImage();
  }, [handleParsedImage]);

  return {
    content: parsedContent,
  };
}

interface TaskContentPreviewerProps {
  taskId: string;
  content: string;
}

export default function TaskContentPreviewer(props: Readonly<TaskContentPreviewerProps>) {
  const { content, taskId } = props;
  const { content: parsedContent } = useParseTaskContent(taskId, content);

  return <ContentPreviewer content={parsedContent} />;
}
